module.exports = __webpack_public_path__ + "static/img/052_TO8_1587_og.af5e26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/052_TO8_1587_og.jpg
// module id = zqQH
// module chunks = 0